var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOn14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.02,
    height: 48.2,
    viewBox: "0 0 57.02 48.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#698ed3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5,
    transform: "translate(0.42 0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M6,0H17.9a6,6,0,0,1,6,6V41a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z",
    transform: "translate(32.098)",
    fill: "#e1f4fb",
    stroke: "#e1f4fb",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 18.439,
    height: 41.551,
    rx: 2,
    transform: "translate(34.829 2.725)",
    fill: "#fff",
    stroke: "#00a3da",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M.84,0H17.6a.84.84,0,0,1,.84.84V18.232a.84.84,0,0,1-.84.84H.84a.84.84,0,0,1-.84-.84V.84A.84.84,0,0,1,.84,0Z",
    transform: "translate(0 27.928)",
    fill: "#e1f4fb",
    stroke: "#e1f4fb",
    strokeMiterlimit: 10,
    strokeWidth: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 15.024,
    height: 14.986,
    rx: 0.84,
    transform: "translate(2.049 29.971)",
    fill: "#fff",
    stroke: "#00a3da",
    strokeMiterlimit: 10,
    strokeWidth: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M5.124,10.218h0a.3.3,0,0,1-.211-.088h0l-2.2-2.193L.513,10.13a.3.3,0,0,1-.213.088.3.3,0,0,1-.3-.3v-4.8A.3.3,0,0,1,.087,4.9l2.191-2.2L.088.511A.3.3,0,0,1,.3,0H5.117a.328.328,0,0,1,.218.088l2.2,2.193L9.732.088A.3.3,0,0,1,10.244.3V5.1h0a.307.307,0,0,1-.088.217l-2.2,2.193,2.2,2.193a.3.3,0,0,1-.213.511Z",
    transform: "translate(4.097 32.014)",
    fill: "#e1f4fb",
    stroke: "#e1f4fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-47,25.2-47,22.7l29.513-.1a1.342,1.342,0,0,0,1.339-1.336,1.332,1.332,0,0,0-1.334-1.328h-8.208A3.44,3.44,0,0,1-29.134,16.5a3.44,3.44,0,0,1,3.439-3.433h8.513a1.027,1.027,0,0,0,1.029-1.023,1.027,1.027,0,0,0-1.029-1.023h-8.154a3.8,3.8,0,0,1-3.8-3.792,3.8,3.8,0,0,1,3.8-3.792h8.082a1.1,1.1,0,0,0,1.1-1.095,1.1,1.1,0,0,0-1.1-1.095H-38.8v-2.5h21.552a3.6,3.6,0,0,1,3.6,3.595,3.6,3.6,0,0,1-3.6,3.595h-8.082a1.3,1.3,0,0,0-1.3,1.292,1.3,1.3,0,0,0,1.3,1.292h8.154a3.53,3.53,0,0,1,3.529,3.523,3.53,3.53,0,0,1-3.529,3.523h-8.513a.937.937,0,0,0-.939.933.937.937,0,0,0,.939.933h8.208a3.835,3.835,0,0,1,3.834,3.828,3.847,3.847,0,0,1-3.83,3.836Z",
    transform: "translate(65.439 17.029)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M9.833,0H7.512a.682.682,0,0,0-.683.681V17.423a.682.682,0,0,1-.683.681H0",
    transform: "translate(18.439 17.029)",
    fill: "none",
    stroke: "#ef705b",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOn14);
export default __webpack_public_path__ + "static/media/on__14_.a4322dee092ec3170104d84d527c43e2.svg";
export { ForwardRef as ReactComponent };